import Call from '../Call.v2';
import {objToQs} from '../Utils';

const BidderCtrHourly = {
    get(type, filters) {
        return Call(`bidder/ctr/${type}?${objToQs(filters)}`);
    },

    getAffids() {
        return Call(`bidder/ctr/affids`);
    },

    getUsedAffids() {
        return Call(`bidder/ctr/usedAffids`);
    }
};

export default BidderCtrHourly;



// WEBPACK FOOTER //
// ./src/services/API/components/BidderCtrHourly.js